module.exports = __webpack_public_path__ + "2dedb3f30c67f825699d0bb0cc85e745.svg";